module.exports = __webpack_public_path__ + "68be86c7b624ae2c685f9ba7fd655be7.jpg";